// src/pages/Home.js
import React from 'react';
import { Container, Box, Typography, Button, Grid, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import InventoryIcon from '@mui/icons-material/Inventory';
import VerifiedIcon from '@mui/icons-material/Verified';
import BuildIcon from '@mui/icons-material/Build';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LatestProducts from '../components/LatestProducts';

const stats = [
  { icon: <DirectionsCarIcon sx={{ fontSize: 36, color: '#f08a0c' }} />, label: 'Renault & Dacia Uzmanı' },
  { icon: <InventoryIcon sx={{ fontSize: 36, color: '#f08a0c' }} />, label: 'Geniş Ürün Kataloğu' },
  { icon: <VerifiedIcon sx={{ fontSize: 36, color: '#f08a0c' }} />, label: 'Orijinal Yedek Parça' },
];

const features = [
  {
    icon: <BuildIcon sx={{ fontSize: 40, color: '#f08a0c' }} />,
    title: 'Orijinal Kalite',
    description: 'Renault ve Dacia onaylı orijinal parçalar, aracınızın fabrika performansını korur.',
  },
  {
    icon: <DirectionsCarIcon sx={{ fontSize: 40, color: '#f08a0c' }} />,
    title: 'Araç Uyumluluğu',
    description: 'Araç marka, model ve serisine göre tam uyumlu parçayı anında bulun.',
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40, color: '#f08a0c' }} />,
    title: 'Hızlı Teslimat',
    description: 'Geniş stok yapımız sayesinde siparişleriniz en kısa sürede hazırlanır.',
  },
  {
    icon: <SupportAgentIcon sx={{ fontSize: 40, color: '#f08a0c' }} />,
    title: 'Uzman Destek',
    description: 'Deneyimli ekibimiz doğru parça seçiminde size her zaman rehberlik eder.',
  },
];

const Home = () => {
  return (
    <Box>

      {/* Hero Bölümü */}
      <Box
        sx={{
          position: 'relative',
          height: { xs: '70vh', md: '85vh' },
          background: "linear-gradient(to right, rgba(10,10,10,0.88) 0%, rgba(10,10,10,0.65) 55%, rgba(10,10,10,0.35) 100%), url('/hero-bg.png') center/cover no-repeat",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
          overflow: 'hidden',
        }}
      >
<Box sx={{ position: 'relative', zIndex: 1, px: 2, maxWidth: 780 }}>
          <Typography
            variant="h2"
            sx={{ mb: 2, fontWeight: 800, fontSize: { xs: '2rem', md: '3rem' }, lineHeight: 1.2 }}
          >
            Renault & Dacia için
            <Box component="span" sx={{ color: '#f08a0c' }}> Orijinal Yedek Parça</Box>
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, color: 'rgba(255,255,255,0.85)', fontWeight: 400 }}>
            Ankara'nın güvenilir oto yedek parça uzmanı. Tüm Renault ve Dacia modelleri için orijinal parça kataloğu.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              component={Link}
              to="/urunler"
              sx={{
                backgroundColor: '#f08a0c',
                '&:hover': { backgroundColor: '#d4780a' },
                px: 4,
                py: 1.5,
                fontWeight: 700,
                borderRadius: 2,
              }}
            >
              Ürün Kataloğu
            </Button>
            <Button
              variant="outlined"
              size="large"
              component={Link}
              to="/contact"
              sx={{
                borderColor: 'white',
                color: 'white',
                px: 4,
                py: 1.5,
                fontWeight: 700,
                borderRadius: 2,
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)', borderColor: 'white' },
              }}
            >
              İletişim
            </Button>
          </Box>
        </Box>
      </Box>

      {/* İstatistik Şeridi */}
      <Box sx={{ backgroundColor: '#1e2128', py: 4 }}>
        <Container maxWidth="lg">
          <Grid container spacing={2} justifyContent="center">
            {stats.map((stat, i) => (
              <Grid item xs={12} sm={4} key={i}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    justifyContent: { xs: 'center', sm: 'flex-start' },
                    px: 2,
                    borderRight: { sm: i < stats.length - 1 ? '1px solid #333' : 'none' },
                  }}
                >
                  {stat.icon}
                  <Typography variant="subtitle1" fontWeight={700} sx={{ color: 'white' }}>
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Neden Biz? — 4 özellik kartı */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography variant="overline" sx={{ color: '#f08a0c', fontWeight: 700, letterSpacing: 2 }}>
            NEDEN İREM OTO?
          </Typography>
          <Typography variant="h4" fontWeight={800} sx={{ mt: 0.5 }}>
            Güvenin Adresi
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
          {features.map((f, i) => (
            <Box key={i} sx={{ flex: { xs: '1 1 calc(50% - 12px)', md: '1 1 calc(25% - 18px)' }, minWidth: 0 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  textAlign: 'center',
                  border: '1px solid #f0f0f0',
                  borderRadius: 3,
                  height: '100%',
                  transition: 'border-color 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    borderColor: '#f08a0c',
                    boxShadow: '0 4px 20px rgba(240,138,12,0.12)',
                  },
                }}
              >
                <Box sx={{ mb: 2 }}>{f.icon}</Box>
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  {f.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                  {f.description}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      </Container>

      {/* Son Eklenen Ürünler */}
      <Box sx={{ backgroundColor: '#fafafa', py: 8 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography variant="overline" sx={{ color: '#f08a0c', fontWeight: 700, letterSpacing: 2 }}>
              ÜRÜN KATALOĞU
            </Typography>
            <Typography variant="h4" fontWeight={800} sx={{ mt: 0.5 }}>
              Son Eklenen Ürünler
            </Typography>
          </Box>
          <LatestProducts />
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Button
              variant="outlined"
              size="large"
              component={Link}
              to="/urunler"
              sx={{
                borderColor: '#f08a0c',
                color: '#f08a0c',
                fontWeight: 700,
                borderRadius: 2,
                px: 4,
                '&:hover': { backgroundColor: '#fff3e0' },
              }}
            >
              Tüm Ürünleri Gör
            </Button>
          </Box>
        </Container>
      </Box>

      {/* CTA Banner */}
      <Box
        sx={{
          backgroundColor: '#f08a0c',
          py: 6,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <EmojiEventsIcon sx={{ fontSize: 48, color: 'white', mb: 1 }} />
          <Typography variant="h4" fontWeight={800} sx={{ color: 'white', mb: 1 }}>
            Aradığınız Parçayı Bulamadınız mı?
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.85)', mb: 3 }}>
            Uzman ekibimiz size özel parça araştırması yapabilir.
          </Typography>
          <Button
            variant="contained"
            size="large"
            component={Link}
            to="/contact"
            sx={{
              backgroundColor: 'white',
              color: '#f08a0c',
              fontWeight: 700,
              px: 4,
              borderRadius: 2,
              '&:hover': { backgroundColor: '#f5f5f5' },
            }}
          >
            Bize Ulaşın
          </Button>
        </Container>
      </Box>

    </Box>
  );
};

export default Home;
